<template lang="pug">
  .width-100
    .updated-at.row.middle.m-bottom-4.m-top-1(v-if='this.content.modifiedBy')
      span.text-small.dark-gray.m-right-1 {{ $t("krea.resource.updatedAt", {date: updatedAtDate}) }}
      span.text-small.dark-gray.author.row.middle {{ updatedByLabel }}
    krea-text-area.m-bottom-5#name(
      edit programTitle
      name='name'
      actionsPlacement='top-end'
      wrap height='100px'
      :placeholder='innerI18n.t("krea.educationalContent.titlePlaceholder", {content: contentTypeTranslation})'
      :info='titleInfo'
      size='title-big'
      :maxCharacters='50'
      :value='activeContentLanguage.name'
      :updateMethod='updateContentName'
    )
    content-features.m-bottom-4
    level-year.m-bottom-2(v-if='showLevelAndYear' edit)
    udls-input(v-if='showUdl' edit)
    krea-custom-field.m-top-2(
      v-for='field of customKreaFields'
      :key='field.id'
      :field='field'
      edit
    )
    .column.width-100.m-bottom-6.m-top-2
      .row.middle.ods-title-container.m-bottom-1
        img(src='@/assets/SDG Wheel_Transparent_WEB.png' alt='sdg\'s wheel logo' width='24px')
        h3.title-small.black.m-left-1
          | {{ innerI18n.t('krea.educationalContent.sdg', {content: contentTypeTranslation}) }}
      .sdg-grid.width-100.m4-left-9(v-if='content.odSs.length')
        span(v-for='ods in content.odSs.map(ods => ods).sort((a,b)=> a.id - b.id)' :key='ods.id')
          img.sdg-card(:src='getOdsLogo(ods.translationId)' :alt='ods.translationId')
      .m4-left-9.text-normal.dark-gray(v-else) {{ innerI18n.t('krea.educationalContent.sdgEmpty') }}
    author-info(:author='content.mainAuthor' :coAuthors='content.coAuthors' krea)
</template>

<script>
import ContentAuthor from '@/components/Krea/EducationalContent/Author'
import ContentFeatures from '@/components/Krea/EducationalContent/Features'
import KreaTextArea from '@/components/Krea/Inputs/KreaTextArea'
import { i18n, innerI18n } from '../../../main'
import { contentType } from '../../../utils/constants'
import { languagesCodesToString } from '../../../constants/languages'
import { mapActions, mapState } from 'vuex'
import UdlsInput from './UdlsInput'
import { kreaCustomFieldTypes } from '@/constants/kreaCustom'
import KreaCustomField from '../Inputs/KreaCustomField'
import LevelYear from './LevelYear'
import userRole from '../../../mixins/userRole'
import AuthorInfo from '../../EducationalPrograms/AuthorInfo'
import moment from 'moment'

export default {
  mixins: [userRole],
  components: {
    AuthorInfo,
    ContentAuthor,
    LevelYear,
    KreaTextArea,
    ContentFeatures,
    UdlsInput,
    KreaCustomField
  },
  data() {
    return {
      innerI18n
    }
  },
  computed: {
    ...mapState({
      activeLanguage: state => state.kreaEducationalContent.activeLanguage,
      content: state => state.kreaEducationalContent.content,
      customFields: state => state.userInfo.customFields,
      innerLocale: state => state.behavior.innerLocale,
      userInfo: state => state.userInfo.userInfo
    }),
    updatedAtDate() {
      return moment(this.content.updatedAt).format('DD/MM/YYYY')
    },
    updatedByLabel() {
      return this.content.modifiedBy === this.userInfo.userId
        ? i18n.t('krea.resource.updatedAtByYou')
        : i18n.t('krea.resource.updatedAtBy', { name: this.content.modifiedByName })
    },
    customKreaFields() {
      return this.customFields && this.customFields.customizedKreaFields
        .filter(field => field.type === kreaCustomFieldTypes.educationalProgram)
    },
    showUdl() {
      return this.customFields && this.customFields.visibleUDL
    },
    showLevelAndYear() {
      return this.customFields && this.customFields.visibleGradeAndEducationalLevel
    },
    contentTypeTranslation() {
      const contentTypeName = Object.keys(contentType).find(key => this.content.contentType === contentType[key])
      return innerI18n.t(`krea.educationalContent.${contentTypeName}`).toLowerCase()
    },
    activeContentLanguage() {
      return this.content
        ? this.content.localizedEducationalPrograms.find(pr => languagesCodesToString[pr.locale] === this.activeLanguage)
        : null
    },
    titleInfo() {
      return {
        title: innerI18n.t('krea.educationalContent.titleInfoTitle', { content: this.contentTypeTranslation }),
        guideLink: { msg: innerI18n.t('krea.educationalContent.details.contentGuideName'), link: this.kreaContentGuide },
        tips: [innerI18n.t('krea.educationalContent.titleInfo', { content: this.contentTypeTranslation })]
      }
    }
  },
  methods: {
    ...mapActions([
      'editKreaLocalizedContentField'
    ]),
    updateContentName(value, field) {
      this.editKreaLocalizedContentField({ field, value, locale: this.activeLanguage })
    },
    getOdsLogo(ods) {
      return require(`@/assets/ods/${this.innerLocale}/${ods}.png`)
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/colors';

.sdg-grid{
  display: grid;
  grid-template-columns: repeat(auto-fill, 50px);
  gap: 5px;
}

.updated-at{
  .author{
    &::before{
      margin-right: 8px;
      margin-top: 3px;
      display: block;
      content: "";
      width: 8px;
      height: 8px;
      background-color: $blue;
      border-radius: 50%;
    }
  }
}

.sdg-card {
  box-shadow: 0 4px 8px 0 $shadow-gray;
  box-sizing: border-box;
  transition: box-shadow 0.3s;
  width: 50px;
  &:hover {
    box-shadow: 0 8px 16px 0 $dark-gray-translusent;
    transform: scale(2);
  }
}
</style>
